import classNames from "classnames";
import style from "./form-field-container.module.css";

export type FieldProps<T> = {
  id: string;
  title?: string;
  onChange: (value: T) => void;
  onFocus?: (id: string) => void;
  onBlur?: (id: string, value: T) => void;
  autoFocus?: boolean;
  error?: string;
  hint?: string;
  tabIndex?: number;
  disabled?: boolean;
  customError?: React.ReactNode;
  height?: number;
  className?: string;
  customErrorMessageComponent?: React.ReactNode;
};

type FieldContainerProps<T> = FieldProps<T> & {
  children: React.ReactNode;
  isFocused: boolean;
};

export function FormFieldContainer<T>({
  id,
  title,
  children,
  error,
  hint,
  isFocused,
  customError,
  height,
  className,
  customErrorMessageComponent,
}: FieldContainerProps<T>) {
  function renderMessage() {
    if (!isFocused && customErrorMessageComponent) {
      return customErrorMessageComponent;
    }

    const regularMessageContent = (() => {
      if (customError) {
        return customError;
      }
      if (error) {
        return <span className={style.error}>{error}</span>;
      }
      if (hint) {
        return <span className={style.hint}>{hint}</span>;
      }
      return null;
    })();

    return <div className={classNames({ [style.message]: regularMessageContent })}>{regularMessageContent}</div>;
  }

  return (
    <div className={style.fieldContainer}>
      {title && (
        <label htmlFor={id} className={style.fieldLabel}>
          {title}
        </label>
      )}
      <div
        className={classNames(style.fieldInputContainer, className, {
          [style.isFocused]: isFocused,
          [style.isError]: (!!error || customError || customErrorMessageComponent) && !isFocused,
        })}
        style={{ height }}
      >
        {children}
      </div>
      {renderMessage()}
    </div>
  );
}
